import { DarwinRoleType, RegistryAllowedRoleType } from './types'

interface IAuthDef {
  actions: string[]
  subject: string
}

interface IAuthRoles {
  roles: Record<DarwinRoleType | RegistryAllowedRoleType, Array<IAuthDef>>
}

export interface IDarwinRealmAuth extends Record<'registry' | 'registrar', IAuthRoles> {
  // roles: Record<DarwinRoleType | RegistryAllowedRoleType, Array<IAuthDef>>
}

const baseRegistryRoles = [
  {
    /** richiesta **/
    subject: 'Request',
    actions: ['Read', 'Update', 'Search'],
  },
  {
    /** richiesta completata**/
    subject: 'CompletedRequest',
    actions: ['Read', 'Write', 'Update', 'Search', 'View'],
  },
  {
    /** richiesta in sospeso **/
    subject: 'PendingRequest',
    actions: ['Read', 'Write', 'Update', 'Search', 'View'],
  },
  {
    /** richiesta approvata **/
    subject: 'ApprovedRequest',
    actions: ['Read', 'Write', 'Update', 'Search', 'View'],
  },
  {
    /** richiesta aggiornata dal Registrar **/
    subject: 'RegistrarUpdatedRequest',
    actions: ['Read', 'Write', 'Update', 'Search', 'View'],
  },
  {
    /** richiesta respinta **/
    subject: 'RejectedRequest',
    actions: ['Read', 'Write', 'Update', 'Search', 'View'],
  },

  {
    /** richiesta inviata **/
    subject: 'SubmittedRequest',
    actions: ['Read', 'Write', 'Update', 'Search', 'View'],
  },
  {
    /** richiesta in scadenza **/
    subject: 'ProcessingExpiredRequest',
    actions: ['Read', 'Write', 'Update', 'Search', 'View'],
  },
  {
    /** richiesta in elaborazione **/
    subject: 'ProcessingRequest',
    actions: ['Read', 'Write', 'Update', 'Search', 'View'],
  },
  {
    /** richiesta cancellata **/
    subject: 'CancelledRequest',
    actions: ['Read', 'Write', 'Update', 'Search', 'View'],
  },
  {
    /** richiesta scaduta **/
    subject: 'ExpiredRequest',
    actions: ['Read', 'Write', 'Update', 'Search', 'View'],
  },
  {
    /**  Info Registrar **/
    subject: 'Registrar',
    actions: ['Read', 'View'],
  },
  {
    /**  Info User **/
    subject: 'User',
    actions: ['Read'],
  },
  // {
  //   subject: 'Ability',
  //   actions: ['Update'],
  // },
  {
    subject: 'AllPendingRequest',
    actions: ['View'],
  },
  {
    subject: 'AllRegistrarUpdated',
    actions: ['View'],
  },
  {
    subject: 'ExpiringRequest',
    actions: ['View'],
  },
  {
    subject: 'AccessDarwin',
    actions: ['Permit'],
  },
]

const baseAssignmentRequestAbilities = [
  {
    subject: 'Request',
    actions: ['assignToMe', 'release'],
  },
  {
    subject: 'ViewAssignationRequests',
    actions: ['all', 'assignedToMe', 'assigned', 'unassigned'],
  },
  {
    subject: 'ViewRequests',
    actions: [
      'pending',
      'registrarUpdated',
      'completed',
      'processing',
      'processingExpired',
      'expired',
      'processingCancelled',
      'cancelled',
      'all',
    ],
  },
]

export const usersAbilities: IDarwinRealmAuth = {
  registry: {
    roles: {
      'darwin-admin': [
        ...baseAssignmentRequestAbilities,
        {
          subject: 'AllPendingRequest',
          actions: ['View'],
        },
        {
          subject: 'AllRegistrarUpdated',
          actions: ['View'],
        },
        {
          subject: 'ViewAssignationRequests',
          actions: ['assignToUser'],
        },
        {
          subject: 'Request',
          actions: ['assignToUser'],
        },
        {
          subject: 'AllRegistrarUpdated',
          actions: ['View'],
        },
        {
          subject: 'Request',
          actions: ['Read', 'Update', 'Search', 'Delete','Edit'],
        },
      ],
      tech: [...baseRegistryRoles, ...baseAssignmentRequestAbilities],
      operator: [...baseRegistryRoles, ...baseAssignmentRequestAbilities],
    },
  },
  registrar: {
    roles: {
      admin: [
        {
          subject: 'PendingRequest',
          actions: ['Read', 'Write', 'Update', 'View'],
        },
        {
          subject: 'ApprovedRequest',
          actions: ['Read', 'Write', 'Update', 'View'],
        },
        {
          subject: 'ExpiredRequest',
          actions: ['Read', 'Write', 'Update', 'View'],
        },
        {
          subject: 'ProcessingExpiredRequest',
          actions: ['Read', 'Write', 'Update'],
        },
        {
          subject: 'ProcessingRequest',
          actions: ['Read', 'Write', 'Update'],
        },
        {
          subject: 'RegistrarUpdatedRequest',
          actions: ['Read', 'Write', 'Update', 'View'],
        },
        {
          subject: 'CompletedRequest',
          actions: ['Read', 'Write', 'Update', 'View'],
        },
        {
          subject: 'User',
          actions: ['Read'],
        },
        {
          subject: 'Anomaly',
          actions: ['Modify'],
        },
        {
          subject: 'Request',
          actions: ['assignToMe', 'release', 'assignToUser'],
        },
        {
          subject: 'ViewAssignationRequests',
          actions: ['all', 'assignedToMe', 'assigned', 'unassigned'],
        },
        {
          subject: 'ViewRequests',
          actions: [
            'pending',
            'registrarUpdated',
            'completed',
            'processing',
            'processingExpired',
            'expired',
            'completed',
            'processingCancelled',
            'cancelled',
            'all',
          ],
        },
        {
          subject: 'AllPendingRequest',
          actions: ['View'],
        },
        {
          subject: 'AllRegistrarUpdated',
          actions: ['View'],
        },
        {
          subject: 'ExpiringRequest',
          actions: ['View'],
        },
        {
          subject: 'AccessDarwin',
          actions: ['Permit'],
        },
      ],
      domain: [
        {
          subject: 'PendingRequest',
          actions: ['Read', 'Write', 'Update', 'Search', 'View'],
        },
        {
          subject: 'ApprovedRequest',
          actions: ['Read', 'Write', 'Update', 'Search', 'View'],
        },
        {
          subject: 'ExpiredRequest',
          actions: ['Read', 'Write', 'Update', 'Search', 'View'],
        },
        {
          subject: 'ProcessingExpiredRequest',
          actions: ['Read', 'Write', 'Update', 'Search'],
        },
        {
          subject: 'ProcessingRequest',
          actions: ['Read', 'Write', 'Update', 'Search'],
        },
        {
          subject: 'RegistrarUpdatedRequest',
          actions: ['Read', 'Write', 'Update', 'Search', 'View'],
        },
        {
          subject: 'CompletedRequest',
          actions: ['Read', 'Write', 'Update', 'Search', 'View'],
        },
        {
          subject: 'User',
          actions: ['Read'],
        },
        {
          subject: 'Anomaly',
          actions: ['Modify'],
        },
        {
          subject: 'Request',
          actions: ['assignToMe', 'release'],
        },
        {
          subject: 'ViewAssignationRequests',
          actions: ['all', 'assignedToMe', 'assigned', 'unassigned'],
        },
        {
          subject: 'ViewRequests',
          actions: [
            'pending',
            'registrarUpdated',
            'completed',
            'processing',
            'processingExpired',
            'expired',
            'completed',
            'processingCancelled',
            'cancelled',
            'all',
          ],
        },
        {
          subject: 'ExpiringRequest',
          actions: ['View'],
        },
        {
          subject: 'AccessDarwin',
          actions: ['Permit'],
        },
      ],
      darwin: [
        {
          subject: 'PendingRequest',
          actions: ['Read', 'Write', 'Update', 'Search', 'View'],
        },
        {
          subject: 'ApprovedRequest',
          actions: ['Read', 'Write', 'Update', 'Search', 'View'],
        },
        {
          subject: 'ExpiredRequest',
          actions: ['Read', 'Write', 'Update', 'Search', 'View'],
        },
        {
          subject: 'ProcessingExpiredRequest',
          actions: ['Read', 'Write', 'Update', 'Search'],
        },
        {
          subject: 'ProcessingRequest',
          actions: ['Read', 'Write', 'Update', 'Search'],
        },
        {
          subject: 'RegistrarUpdatedRequest',
          actions: ['Read', 'Write', 'Update', 'Search', 'View'],
        },
        {
          subject: 'CompletedRequest',
          actions: ['Read', 'Write', 'Update', 'Search', 'View'],
        },
        {
          subject: 'User',
          actions: ['Read'],
        },
        {
          subject: 'Anomaly',
          actions: ['Modify'],
        },
        // {
        //   subject: 'ViewAssignationRequests',
        //   actions: [''],
        // },
        {
          subject: 'ViewRequests',
          actions: [
            'pending',
            'registrarUpdated',
            'completed',
            'processing',
            'processingExpired',
            'expired',
            'completed',
            'processingCancelled',
            'cancelled',
            'all',
          ],
        },
        {
          subject: 'ExpiringRequest',
          actions: ['View'],
        },
        {
          subject: 'AccessDarwin',
          actions: ['Permit'],
        },
      ],
    },
  },
}
